import React, { lazy, Suspense, useMemo } from 'react';
const CondensedMobileView = lazy(() => import('src/common/refactoredComponents/condensedMobileView/CondensedMobileView'));
import { AccountTitle } from './CondensedMobileView.styled';
import {  MainWrapper } from './CondensedMobileViewSets.styled';
import { WHITE_FONT_COLOR, LARGE_TEXT_PX, TITLE_FONT_COLOR, SEMANTIC_TEXT_PX, GREY_PRODUCT_LIST_COLOR } from 'src/styles/fonts/MCFontConstants';

const CondensedMobileViewFees = ({
    feesImplant = [],
    feesInstrument = [],
    section,
    cartPage,
    t,
    isOrderScreen,
    isOrderDetailTab,
    expandedProducts,
    expandedProductsItemList,
    toggleProduct,
    toggleProductItemList,
    isEquityTemplate,
    orderType,
    showCheckBox,
    isCartScreenOrProductGuide,
    isEquityTemp,
    handleSetItemClick,
    removeCounter,
    addCounter,
    isFromSurgeryTemplate,
    isTemplateDetail,
    isEquity,
    handleLocationChange,
    inventoryShipping,
    handleSetSelection,
    isReviewSubmitScreen,
    updateProductQuantity,
    deleteProduct,
    isConsignmentAdd,
    marginOnMediumDeviceSets,
    marginOnLargeDeviceSets,
    marginOnMobileDeviceSets,
    minWidthSets,
    marginSets,
    itemCardsContainerMinMobWidthSets,
    marginRight
}) => {
    const feesImplantItems = useMemo(() =>
        feesImplant.map((item, index) => (
            <div key={index} style={{ width: '100%' }}>
                <Suspense fallback={<div>{t('common.loadingText')}</div>}>
                    <CondensedMobileView
                        isEquityTemplate={isEquityTemplate}
                        orderType={orderType}
                        showCheckBox={showCheckBox}
                        isCartScreenOrProductGuide={isCartScreenOrProductGuide}
                        onToggle={() =>
                            isOrderScreen
                                ? isOrderDetailTab
                                    ? toggleProductItemList(item?.productKey)
                                    : toggleProduct(item?.productKey)
                                : toggleProduct(item?.productKey)
                        }
                        isExpanded={
                            isOrderScreen
                                ? isOrderDetailTab
                                    ? expandedProductsItemList?.has(item?.productKey)
                                    : expandedProducts?.has(item?.productKey)
                                : expandedProducts?.has(item?.productKey)
                        }
                        cartPage={cartPage}
                        isEquityTemp={isEquityTemp}
                        marginOnMediumDevice={marginOnMediumDeviceSets}
                        marginOnLargeDevice={marginOnLargeDeviceSets}
                        marginOnMobileDevice={marginOnMobileDeviceSets}
                        key={`${item.cfn}-${0}`}
                        isCounterButton={true}
                        minWidth={minWidthSets}
                        setOrItemDetails={item}
                        removeCount={() =>
                            item.quantity > 0 &&
                            removeCounter(item?.productKey, item.isSet, item)
                        }
                        addCount={(item) => addCounter(item)}
                        cardType={'items'}
                        count={item.count}
                        showBrand={true}
                        showType={true}
                        margin={marginSets}
                        setNameColor={TITLE_FONT_COLOR}
                        setNameFontSizeMobile={SEMANTIC_TEXT_PX}
                        setNameFontSizeDesktop={SEMANTIC_TEXT_PX}
                        itemCardsContainerMinMobWidth={itemCardsContainerMinMobWidthSets}
                        onSetItemClick={handleSetItemClick}
                        clickable={true}
                        basePrice={item?.basePrice}
                        extPrice={item?.extPrice}
                        productSearchFlag={true}
                        productType={'Cart'}
                        isCart={true}
                        setIsQuantityMoreThan50={true}
                        description={item.description}
                        background={index % 2 !== 0 ? GREY_PRODUCT_LIST_COLOR : ''}
                        section={section}
                        isEquity={isEquity}
                        isTemplateDetail={isTemplateDetail}
                        isFromSurgeryTemplate={isFromSurgeryTemplate}
                        isOrderDetailTab={isOrderDetailTab}
                        handleLocationChange={handleLocationChange}
                        inventoryShipping={inventoryShipping}
                        handleSetSelection={handleSetSelection}
                        isReviewSubmitScreen={isReviewSubmitScreen}
                        isOrderScreen={isOrderScreen}
                        updateProductQuantity={updateProductQuantity}
                        marginRight={marginRight}
                    />
                </Suspense>
            </div>
        ))
    , [feesImplant, isEquityTemplate, orderType, showCheckBox, isCartScreenOrProductGuide, isOrderScreen, isOrderDetailTab, expandedProductsItemList, expandedProducts, cartPage, isEquityTemp, handleSetItemClick, removeCounter, addCounter, isFromSurgeryTemplate, isTemplateDetail, isEquity, handleLocationChange, inventoryShipping, handleSetSelection, isReviewSubmitScreen, updateProductQuantity]);

    const feesInstrumentItems = useMemo(() =>
        feesInstrument.map((item, index) => (
            <div key={index} style={{ width: '100%' }}>
                <Suspense fallback={<div>{t('common.loadingText')}</div>}>
                    <CondensedMobileView
                        isEquityTemplate={isEquityTemplate}
                        orderType={orderType}
                        showCheckBox={showCheckBox}
                        isOrderDetailTab={isOrderDetailTab}
                        isCartScreenOrProductGuide={isCartScreenOrProductGuide}
                        onToggle={() =>
                            isOrderScreen
                                ? isOrderDetailTab
                                    ? toggleProductItemList(item?.productKey)
                                    : toggleProduct(item?.productKey)
                                : toggleProduct(item?.productKey)
                        }
                        isExpanded={
                            isOrderScreen
                                ? isOrderDetailTab
                                    ? expandedProductsItemList?.has(item?.productKey)
                                    : expandedProducts?.has(item?.productKey)
                                : expandedProducts?.has(item?.productKey)
                        }
                        cartPage={cartPage}
                        isEquityTemp={isEquityTemp}
                        marginOnMediumDevice={marginOnMediumDeviceSets}
                        marginOnLargeDevice={marginOnLargeDeviceSets}
                        marginOnMobileDevice={marginOnMobileDeviceSets}
                        key={`${item.cfn}-${0}`}
                        isCounterButton={true}
                        minWidth={minWidthSets}
                        setOrItemDetails={item}
                        removeCount={() =>
                            item.quantity > 0 &&
                            removeCounter(item?.productKey, item.isSet, item)
                        }
                        addCount={() => addCounter(item)}
                        cardType={'items'}
                        count={item.count}
                        showBrand={true}
                        showType={true}
                        margin={marginSets}
                        setNameColor={TITLE_FONT_COLOR}
                        setNameFontSizeMobile={SEMANTIC_TEXT_PX}
                        setNameFontSizeDesktop={SEMANTIC_TEXT_PX}
                        itemCardsContainerMinMobWidth={itemCardsContainerMinMobWidthSets}
                        onSetItemClick={handleSetItemClick}
                        clickable={true}
                        basePrice={item?.basePrice}
                        extPrice={item?.extPrice}
                        productSearchFlag={true}
                        productType={'Cart'}
                        isCart={true}
                        setIsQuantityMoreThan50={true}
                        description={item.description}
                        background={index % 2 !== 0 ? GREY_PRODUCT_LIST_COLOR : ''}
                        section={section}
                        isEquity={isEquity}
                        isTemplateDetail={isTemplateDetail}
                        isFromSurgeryTemplate={isFromSurgeryTemplate}
                        deleteProduct={deleteProduct}
                        isConsignmentAdd={isConsignmentAdd}
                        handleLocationChange={handleLocationChange}
                        inventoryShipping={inventoryShipping}
                        handleSetSelection={handleSetSelection}
                        isReviewSubmitScreen={isReviewSubmitScreen}
                        isOrderScreen={isOrderScreen}
                        updateProductQuantity={updateProductQuantity}
                        marginRight={marginRight}
                    />
                </Suspense>
            </div>
        ))
    , [feesInstrument, isEquityTemplate, orderType, showCheckBox, isOrderDetailTab, isCartScreenOrProductGuide, isOrderScreen, expandedProductsItemList, expandedProducts, cartPage, isEquityTemp, handleSetItemClick, removeCounter, addCounter, isFromSurgeryTemplate, isTemplateDetail, isEquity, handleLocationChange, inventoryShipping, handleSetSelection, isReviewSubmitScreen, updateProductQuantity, deleteProduct, isConsignmentAdd]);

    return (
        <MainWrapper data-testid="setItemDetails-mainWrapper">
            {(feesImplant.length > 0 || feesInstrument.length > 0) &&
                !(section === 'template') &&
                !cartPage && (
                    <AccountTitle 
                        backgroundColor={WHITE_FONT_COLOR}
                        fontSize={LARGE_TEXT_PX}
                        data-testid="sets-account-title"
                    >
                        {t('common.feeLabel')} (
                        {feesImplant.length + feesInstrument.length})
                    </AccountTitle>
                )}
            {feesImplantItems}
            {feesInstrumentItems}
        </MainWrapper>
    );
};

export default CondensedMobileViewFees;
